import { Link } from 'react-router-dom';

import { SignInForm } from '@/components/forms/auth/SignInForm';
import { Logo } from '@/components/global/Logo';
import { orgPath } from '@/helpers/org-path.helper';

export const SignIn = ({
  isInternalHostname,
}: {
  isInternalHostname: boolean;
}) => {
  return (
    <div className="mx-auto flex min-h-full w-full max-w-[400px] flex-col justify-center px-4 max-sm:items-center lg:w-1/2">
      {isInternalHostname && <Logo />}
      {/* The heading lives in the form - it changes with the step. */}
      <div className="mt-10">
        <SignInForm />
      </div>
      <p className="as-title-03 mt-4 text-center text-muted-foreground">
        Don&apos;t have an account?
        <Link
          to={orgPath('/auth/sign-up')}
          className="as-strong ml-2 text-brand-700"
        >
          Sign up for free
        </Link>
      </p>
    </div>
  );
};
